define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("manager-templates/data-sources/app-install/appInstallEditView.tmpl");
    var Config = require("assets/config/entities/config.json");
    var Button = require("ui/button/Button");
    var ToggleButton = require("ui/toggle-button/toggleButton");
    var InlineTextarea = require("ui/inline-textarea/InlineTextarea");
    var InputField = require("ui/input-field/InputField");
    var KpContent = require("ui.components/kpContent/kpContent");
    var HtmlSanitizerUtils = require("HtmlSanitizerUtils");
    var Bubble = require("ui/bubble/Bubble");

    var LOGO_PREVIEW_STATES = {
        NONE: "none",
        LOADING: "loading",
        LOADED: "loaded",
        ERROR: "error"
    };

    var SANITIZER_ALLOWING_TAGS = {
        "A": [
            "HREF",
            "TARGET"
        ]
    };

    var BROKEN_URL_PICTURE = window.leImageBaseUrl + "src/modules/manager/assets/img/broken-image.png";
    var PLACEHOLDER_URL_PICTURE = "https://www.gomobile.com/mobile-icon.png";

    var AppInstallEditView = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        AppInstallEditView = Marionette.ItemView.extend({
            template : template,
            className : "app-install-edit-container-view",
            ui : {
                cancelButton: ".button-cancel",
                doneButton: ".button-done",
                nextButton: ".button-next",
                appInstallNameInputContainer: ".app-install-name-container .input-container",
                appInstallDescriptionContainer: ".app-install-description-container",
                appInstallLogoUriInputContainer: ".app-install-logo-uri-container .input-container",
                appInstallLogoPreviewInfo: ".app-install-logo-uri-container .icon",
                appInstallLogoPreview: ".app-install-image",
                learnMore: ".learn-more",
                learnMoreAppInst: ".learn-more-app-inst",
                createAppButtonContainer: ".button-create-app-install",
                appInstallAuthenticationDetailsSection: ".app-install-authentication-details-section",
                appInstallKeyContainer: ".app-install-key-container",
                appInstallActivationContainer: ".toggle-container",
                copyToClipboard: ".copy-to-clipboard",
                activationToggleSection: ".activation-toggle-section"
            },
            uiComponents : {
                copyButton: {
                    type: Button,
                    options: {
                        el: "view.ui.copyToClipboard",
                        permutation: Button.PERMUTATION.BLUELINK
                    },
                    events: {
                        "click": "_onCopyToClipboardClick"
                    }
                },
                appInstallName:{
                    type: InputField,
                    options: {
                        el: "view.ui.appInstallNameInputContainer",
                        permutation: InputField.Permutation.B,
                        value: "view._getAppInstallName",
                        maxLength: "view._getMaxNameLength"
                    },
                    events: {
                        change: "_onAppInstallNameChange"
                    }
                },
                description: {
                    type: InlineTextarea,
                    options: {
                        permutation: InlineTextarea.PERMUTATION.D,
                        container: "view.ui.appInstallDescriptionContainer",
                        value: "view._getAppInstallDescription"
                    },
                    events: {
                        change: "_onAppInstallDescriptionChange"
                    }
                },
                appInstallLogoUri:{
                    type: InputField,
                    options: {
                        el: "view.ui.appInstallLogoUriInputContainer",
                        permutation: InputField.Permutation.B,
                        placeholder: "view._getSoftwareLogoPlaceholder",
                        value: "view._getInitialAppInstallLogoUri"
                    },
                    events: {
                        onblur: "_onAppInstallLogoBlur",
                        change: "_onAppInstallLogoChange"
                    }
                },
                createAppInstallButton: {
                    type: Button,
                    options: {
                        el: "view.ui.createAppButtonContainer",
                        permutation: Button.PERMUTATION.BTN_PRIMARY
                    },
                    events: {
                        "click": "_saveAppInstall"
                    }
                },
                appInstallIKey:{
                    type: InputField,
                    options:{
                        el:"view.ui.appInstallKeyContainer",
                        readonly: true,
                        permutation: InputField.Permutation.B,
                        value: "view._getAppInstallIdValue"
                    }
                },
                cancelButton: {
                    type: Button,
                    options: {
                        el: "view.ui.cancelButton",
                        permutation: Button.PERMUTATION.LINK
                    },
                    events: {
                        "click": "_onCancelClick"
                    }
                },
                doneButton: {
                    type: Button,
                    options: {
                        el: "view.ui.doneButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY,
                        tooltipAlign: Button.TOOLTIP_ALIGN.RIGHT,
                        initState: Button.STATES.DISABLED
                    },
                    events: {
                        "click": "_saveAppInstall"
                    }
                },
                nextButton: {
                    type: Button,
                    options: {
                        el: "view.ui.nextButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY,
                        tooltipAlign: Button.TOOLTIP_ALIGN.RIGHT
                    },
                    events: {
                        "click": "_onNextClick"
                    }
                }
            },

            modelEvents: {
                "change:client_id": "_onAppInstallIdChange"
            },

            events: {
                "mouseenter @ui.appInstallLogoPreviewInfo": "_showLogoUriBubble",
                "mouseleave @ui.appInstallLogoPreviewInfo": "_closeLogoUriBubble"
            },
            customTemplateHelpers: function() {
                var videoUrl = this.softwareModel.getVideoUrl();
                var showVideo = !_.isEmpty(videoUrl);
                var isStructuredInstructions = this.softwareModel.isStructuredInstructionType();
                var isMarkedDownInstructions = this.softwareModel.isMarkdownInstructionType();
                var instructions = isStructuredInstructions ? this._getInstructionsList() : HtmlSanitizerUtils.sanitizeAndCleanHtml(this.softwareModel.getInstructions(), SANITIZER_ALLOWING_TAGS);
                var description = this._getLongDescription();
                var showInstructions = !_.isEmpty(instructions);
                return {
                    showVideo: showVideo,
                    videoUrl: videoUrl,
                    isStructuredInstructions: isStructuredInstructions,
                    isMarkedDownInstructions: isMarkedDownInstructions,
                    instructions: instructions,
                    description: description,
                    showInstructions: showInstructions
                };
            },
            initialize : function (options) {
                LEManager.logger.debug("AppInstallEditView:initialize");
                this.channel = LEManager.media.channel("conversationSources");
                this.softwareModel = options.softwareModel;

                this.model.setLogoUriState(LOGO_PREVIEW_STATES.NONE);
                this._bindEvents();
            },
            onRender: function(){
                this._renderKpContent();
                this._renderAppInstallActivationToggleControl();
                this._setControlsVisibility();
                this._updateAppInstallLogoPreview();
            },
            _bindEvents: function(){
                this.listenTo(this, "page:closeButtonClick", this._onCancelClick);
                this.listenTo(this.channel, "appInstall:logo:preview:error", this._showErrors);
            },
            _renderAppInstallActivationToggleControl: function(){
                if (!this.model.isNew() && !_.has(this.uiComponents, "appInstallActivation")) {
                    this.uiComponents.host$.createAndRender("appInstallActivation", {
                        type: ToggleButton,
                        options: {
                            container: "view.ui.appInstallActivationContainer",
                            transition: ToggleButton.TRANSITION.FAST,
                            checked: "view._getAppInstallEnableStatus",
                            tooltip: {
                                active: "",
                                inactive: LE.translator.translate("LEManager.dataSources.conversationSources.appInstallEdit.state.inactive")
                            }
                        },
                        events: {
                            "toggleButton:change": "_onAppInstallActivationChange"
                        }
                    });
                    this.ui.activationToggleSection.removeClass("hide");

                }
            },
            _renderKpContent: function(){
                var kpId = this._getLearnMoreKpId();
                if (!_.isEmpty(kpId)){
                    if (!_.has(this.uiComponents, "learnMoreAppInst")) {
                        this.uiComponents.host$.createAndRender("learnMoreAppInst", {
                            type: KpContent,
                            options: {
                                container: "view.ui.learnMoreAppInst",
                                KPLink: LE.translator.translate("LEFramework.global.captions.learnMore"),
                                kpID: "view._getLearnMoreKpId",
                                showKPIcon: true
                            }
                        });
                    }
                    if (!_.has(this.uiComponents, "learnMoreButton")) {
                        this.uiComponents.host$.createAndRender("learnMoreButton", {
                            type: KpContent,
                            options: {
                                container: "view.ui.learnMore",
                                KPLink: LE.translator.translate("LEFramework.global.captions.learnMore"),
                                kpID: "view._getLearnMoreKpId",
                                showKPIcon: true
                            }
                        });
                    }
                }
            },
            _setControlsVisibility: function(){
                var appInstallIdExists = !this.model.isNew();
                this.ui.appInstallAuthenticationDetailsSection.toggleClass("hide", !appInstallIdExists);
                this.ui.createAppButtonContainer.toggleClass("hide", appInstallIdExists);
                this.uiComponents.doneButton.setEnabled(appInstallIdExists);
            },
            _getAppInstallEnableStatus: function(){
                return this.model.getEnabled();
            },
            _getAppInstallIdValue: function(){
                return this.model.isNew() ? "" : this.model.id;
            },
            _getLongDescription: function(){
                return this.softwareModel.getLongDescription();
            },
            _getAppInstallName: function(){
                return this.model.getName();
            },
            _getAppInstallDescription: function(){
                return this.model.getDescription();
            },
            _getInitialAppInstallLogoUri: function() {
                return this.model.getLogoUri() === this.softwareModel.getLogoUri() ? "" : this.model.getLogoUri();
            },
            _getMaxNameLength: function(){
                return Config.validators.appInstall.maxNameLength;
            },
            _getInstructionsList: function(){
                var instructions = this.softwareModel.getInstructions();
                return _.map(instructions, function(instruction){
                    return {
                        "instruction": HtmlSanitizerUtils.sanitizeAndCleanHtml(instruction, SANITIZER_ALLOWING_TAGS)
                    };
                });
            },
            _updateAppInstallLogoPreview: function() {
                this.model.setLogoUriState(LOGO_PREVIEW_STATES.LOADING);

                this.ui.appInstallLogoPreview.on("error", _.bind(function(){
                    this._updateAppInstallLogoPreviewState(LOGO_PREVIEW_STATES.ERROR);
                }, this));
                this.ui.appInstallLogoPreview.on("load", _.bind(function(){
                    this._updateAppInstallLogoPreviewState(LOGO_PREVIEW_STATES.LOADED);
                }, this));

                this.ui.appInstallLogoPreview.attr("src", this.model.getLogoUri());
            },
            _updateAppInstallLogoPreviewState: function(state) {
                this.ui.appInstallLogoPreview.off("error");
                this.ui.appInstallLogoPreview.off("load");
                this.model.setLogoUriState(state);
                this.channel.trigger("appInstall:logo:preview:updated");
            },
            _saveAppInstall: function() {
                //We need to show the loader here and not in the controller, because we have an async call.
                LEManager.showLoader();

                //The defer is needed because we want the blur event to happen before this.
                _.defer(_.bind(function() {
                    if (this.model.getLogoUriState() === LOGO_PREVIEW_STATES.LOADING) {
                        this.listenToOnce(this.channel, "appInstall:logo:preview:updated", _.bind(function() {
                            this.channel.trigger("appInstall:save", this.model);
                        }, this));
                    }
                    else {
                        this.channel.trigger("appInstall:save", this.model);
                    }
                },this));
            },
            _showErrors: function(errorObj) {
                this._clearErrors();
                if (_.has(errorObj, this.model.KEYS.CLIENT_NAME)) {
                    this.uiComponents.appInstallName.setError(true, errorObj[this.model.KEYS.CLIENT_NAME]);
                }
                if (_.has(errorObj, this.model.KEYS.LOGO_URI)) {
                    this.uiComponents.appInstallLogoUri.setError(true, errorObj[this.model.KEYS.LOGO_URI]);
                    this.ui.appInstallLogoPreview.attr("src", BROKEN_URL_PICTURE);
                }
                if (_.has(errorObj, this.model.KEYS.DESCRIPTION)) {
                    this.uiComponents.description.setError(true, errorObj[this.model.KEYS.DESCRIPTION]);
                }
            },
            _getSoftwareLogoName: function() {
                var logoUrl = this.softwareModel.getLogoUri();
                var logoUrlSplit = logoUrl.split("/");
                return logoUrlSplit[logoUrlSplit.length - 1];
            },
            _getSoftwareLogoPlaceholder: function() {
                return PLACEHOLDER_URL_PICTURE;
            },
            _showLogoUriBubble: function() {
                this._closeLogoUriBubble(null, true);
                this.uiComponents.host$.createAndRender("logoUriBubble", {
                    type: Bubble,
                    options: {
                        targetControl: this.ui.appInstallLogoPreviewInfo,
                        position: Bubble.POSITION.RIGHT,
                        showCloseButton: false,
                        isDelayed: true,
                        text: LE.translator.translate("LEManager.dataSources.conversationSources.appInstallEdit.previewLogo.info")
                    }
                });
            },
            _closeLogoUriBubble: function(event, force) {
                if (this.uiComponents.logoUriBubble) {
                    this.uiComponents.logoUriBubble.close(force);
                }
            },
            _clearErrors: function() {
                this.uiComponents.appInstallName.setError(false);
                this.uiComponents.appInstallLogoUri.setError(false);
            },
            _onAppInstallIdChange: function(){
                this._renderAppInstallActivationToggleControl();
                this._setControlsVisibility();
                this.uiComponents.appInstallIKey.setValue(this.model.id);
                this.uiComponents.doneButton.setEnabled(true);
            },
            _onAppInstallLogoBlur: function(componentId, eventName, value){
                this._updateAppInstallLogoPreview();
            },
            _onAppInstallLogoChange: function(componentId, eventName, value){
                var logoUri = value;
                if (value === this._getSoftwareLogoName() || value === "") {
                    logoUri = this.softwareModel.getLogoUri();
                }
                this.channel.trigger("appInstall:change:logoUri", logoUri);
            },
            _onAppInstallNameChange: function(componentId, eventName, value){
                this.channel.trigger("appInstall:change:name", value);
            },
            _onAppInstallDescriptionChange: function(componentId, eventName, value) {
                this.channel.trigger("appInstall:change:description", value);
            },
            _onAppInstallActivationChange: function(componentId, eventName, value){
                this.channel.trigger("appInstall:change:enabled", value);
            },
            _getLearnMoreKpId: function(){
                return this.softwareModel.getKpId();
            },
            _onCancelClick: function(){
                this.channel.trigger("appInstall:cancel:click");
            },
            _onNextClick: function(){
                this.channel.trigger("appInstall:next:click");
            },
            _onCopyToClipboardClick: function() {
                this.uiComponents.appInstallIKey.select();
                var copyIsSuccess = document.execCommand("copy");
                if (copyIsSuccess) {
                    LEManager.notifier.showSuccess({
                        content: LE.translator.translate("LEManager.dataSources.conversationSources.appInstallEdit.copy.to.clipboard.success")
                    });
                }
            },
            onInvalid: function(model, errors){
                this._showErrors(errors);
            },
            onClose: function () {
                LEManager.logger.debug("AppInstallEditView:onClose");
            }

        });
    }

    LE.module("LEManager", moduleDefinition);

    return AppInstallEditView;
});
